import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { OperatorSettings } from '../../../models/operator-settings.model';

export const OperatorSettingsActions = createActionGroup({
  source: 'Operator Settings',
  events: {
    Load: emptyProps(),
    'Load Success': props<{ settings: OperatorSettings[] }>(),
    'Load Failure': props<{ error: string }>(),

    Update: props<{ id: number; data: Partial<OperatorSettings> }>(),
    'Update Success': props<{ settings: OperatorSettings[] }>(),
    'Update Failure': props<{ error: string }>(),

    'Upload PSIDs': props<{ formData: FormData }>(),
    'Upload PSIDs Success': props<{ ok: number; error: number }>(),
    'Upload PSIDs Failure': props<{ error: string }>(),

    'Upload Unicorn Quotas': props<{ file: File }>(),
    'Upload Unicorn Quotas Success': emptyProps(),
    'Upload Unicorn Quotas Failure': props<{ error: string }>(),

    'Download Unicorn Mappings': emptyProps(),
    'Download Unicorn Mappings Success': emptyProps(),
    'Download Unicorn Mappings Failure': props<{ error: string }>(),

    'Download Unicorn Template': emptyProps(),
    'Download Unicorn Template Success': emptyProps(),
    'Download Unicorn Template Failure': props<{ error: string }>(),

    'Upload Crm Id': props<{ file: File }>(),
    'Upload Crm Id Success': emptyProps(),
    'Upload Crm Id Failure': props<{ error: string }>(),

    'Download Crm Id Template': emptyProps(),
    'Download Crm Id Template Success': emptyProps(),
    'Download Crm Id Template Failure': props<{ error: string }>(),

    'Upload Traffic Density File': props<{
      file: File;
      country: string;
      countryName: string;
    }>(),
    'Upload Traffic Density File Success': emptyProps(),
    'Upload Traffic Density File Failure': props<{ error: string }>(),

    'Download Traffic Density Template': emptyProps(),
    'Download Traffic Density Template Success': emptyProps(),
    'Download Traffic Density Template Failure': props<{ error: string }>(),

    'Download Traffic Density Current File': props<{ country: string }>(),
    'Download Traffic Density Current File Success': emptyProps(),
    'Download Traffic Density Current File Failure': props<{ error: string }>(),
  },
});
